const TileCourtCase = ({ data = {}, t }) => {
  const str = (v) => (typeof v === "string" ? v.trim() : "");
  const caseName = str(data.case_name);
  const content = str(data.content);
  const dateFiled = str(data.date_filed);
  const docketNumber = str(data.docket_number);
  if (!caseName && !content && !dateFiled && !docketNumber) return null;

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {caseName && (
          <p
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: t.textPrimary,
              margin: 0,
              lineHeight: 1.4,
            }}
          >
            {caseName}
          </p>
        )}
        {content && (
          <p
            style={{
              fontSize: 13,
              color: t.textSecondary,
              margin: 0,
              lineHeight: 1.6,
              wordBreak: "break-word",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {content}
          </p>
        )}
        {(dateFiled || docketNumber) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 16,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            {dateFiled && (
              <span
                style={{
                  fontSize: 11,
                  padding: "2px 8px",
                  borderRadius: 6,
                  background: t.labelBg,
                  border: `1px solid ${t.labelBorder}`,
                  color: t.labelText,
                }}
              >
                {dateFiled}
              </span>
            )}
            {docketNumber && (
              <span
                style={{
                  fontSize: 11,
                  color: t.textMuted,
                  fontFamily: "monospace",
                }}
              >
                {docketNumber}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileCourtCase;
